// Override the brand CSS custom properties on a container subtree (no global
// mutation), so a branded screen themes only itself. Falls back to default blue.
export function accentVars(accent) {
  if (!accent || !/^#[0-9a-fA-F]{6}$/.test(accent)) return {};
  return { '--blue': accent, '--blue-pale': `${accent}14`, '--hairline-blue': `${accent}55` };
}
